import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { ActivityLogProps, ActivityLogUserProps } from "../../types/activityLog";

export interface ActivityLogsState {
  logs: ActivityLogProps[];
  users: ActivityLogUserProps[];
  totalLogs: number;
  loading: boolean;
  error: string | null;
}

const initialState: ActivityLogsState = {
  logs: [],
  users: [],
  totalLogs: 0,
  loading: false,
  error: null,
};

type FetchActivityLogsDataProps = {
  page: number;
  size?: number;
  fromDate?: string | null;
  toDate?: string | null;
  action?: string | null;
  model_type?: string | null;
  user_id?: number | null;
};

export const fetchActivityLogsData = createAsyncThunk(
  "fetchActivityLogsData",
  async (req: FetchActivityLogsDataProps) => {
    let response: any;
    await GET(`/v1/admin/activity-logs`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const activityLogsSlice = createSlice({
  name: "activityLogs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchActivityLogsData.pending, (state) => {
      state.logs = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchActivityLogsData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.logs = action.payload.data.data.records;
        state.totalLogs = action.payload.data.data.total_records;
        state.users = action.payload.data.data.users || [];
        state.error = null;
      } else {
        state.logs = [];
        state.totalLogs = 0;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchActivityLogsData.rejected, (state, action: any) => {
      state.logs = [];
      state.totalLogs = 0;
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const getActivityLogs = (state: RootState) => state.activityLogs.logs;
export const getTotalActivityLogs = (state: RootState) =>
  state.activityLogs.totalLogs;
export const getActivityLogsUsers = (state: RootState) =>
  state.activityLogs.users;
export const getActivityLogsLoading = (state: RootState) =>
  state.activityLogs.loading;

export default activityLogsSlice.reducer;
